import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {ConsentsFormService} from '../../../services/consents-form.service';
import {LogService} from '../../../services/log.service';
import {ReportService} from '../../../services/report.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
    selector: 'app-completed-consents',
    templateUrl: './completed-consents.component.html',
    styleUrls: ['./completed-consents.component.scss']
})
export class CompletedConsentsComponent implements OnInit, AfterViewInit {
    @Input() user: any;
    @Input() children: any[];
    consents: MatTableDataSource<any> = new MatTableDataSource<any>();
    nonGDPRConsents: MatTableDataSource<any> = new MatTableDataSource<any>();
    customForms: MatTableDataSource<any> = new MatTableDataSource<any>();
    columnsToDisplay: string[];
    selectedOption: any;
    consentsHistory: any[] = [];
    historyLoading: boolean;
    affirmationsHistory: any[] = [];
    historyAffirmationsLoading: boolean;
    customFormDisplayColumns = ['title', 'displayName', 'modified_by_displayName', 'modified_at', 'actions'];
    // options = [{id: 1, label: 'Τρέχουσα κατάσταση συναινέσεων GDPR'}, {id: 2, label: ' Τρέχουσα κατάσταση λοιπών συναινέσεων'}, {id: 3, label: 'Ιστορικό'}];
    options = [{id: 1, label: 'Κατάσταση προσαρμοσμένων δηλώσεων'}, {id: 2, label: 'Κατάσταση συναινέσεων GDPR'}, {
        id: 3,
        label: 'Κατάσταση εγγραφών'
    }, {id: 4, label: 'Ιστορικό συναινέσεων'}, {id: 5, label: 'Ιστορικό εγγραφών'}];
    displayCards = [];

    constructor(public commonService: CommonService,
                public toastMessagesService: ToastMessagesService,
                private logService: LogService,
                public router: Router,
                private reportService: ReportService,
                public consentsFormService: ConsentsFormService) {

        this.columnsToDisplay = ['formTitle', 'displayName', 'modified_by', 'consentDate', 'actions'];
        this.historyLoading = true;
        this.historyAffirmationsLoading = true;
    }

    async ngOnInit() {
        this.selectedOption = this.options[0];
        await this.initializeConsents();
    }

    async ngAfterViewInit() {
        // await this.initializeConsentsHistory();
        // await this.initializeAffirmationsHistory();
        // await this.initializeCustomFormsHistory();
    }

    async initializeConsentsHistory() {
        try {
            this.historyLoading = true;

            this.consentsHistory = await this.logService.getUserLogs();

        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε το ιστορικό των συναινέσεων');
        } finally {
            this.historyLoading = false;
        }
    }

    async initializeCustomFormsHistory() {
        try {
            this.historyLoading = true;
            const customFormsRequest = await this.logService.getUserCustomFormsResults(this.children);
            // ['displayName', 'title', 'modified_by_displayName', 'modified_at', 'actions'];
            for (const form of customFormsRequest) {
                form.displayName = `${form.child_first_name} ${form.child_last_name}`;
                form.modified_by_displayName = `${form.modified_by_first_name} ${form.modified_by_last_name}`;
            }

            this.customForms = new MatTableDataSource<any>(customFormsRequest);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε το ιστορικό των συναινέσεων');
        } finally {
            this.historyLoading = false;
        }
    }

    async initializeAffirmationsHistory() {
        try {
            this.historyAffirmationsLoading = true;
            this.affirmationsHistory = await this.logService.getUserAffirmationLogs();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε το ιστορικό των εγγραφών');
        } finally {
            this.historyAffirmationsLoading = false;
        }
    }


    async initializeConsents() {
        const consentRecords = [];
        try {

            const originalForms = await this.reportService.getCustomFormsReportForChildrenHistory();
            for (const form of originalForms) {
                    form.formTitle = form.title;
                    form.displayName = `${form.child_first_name} ${form.child_last_name}`;
                    form.modified_by = form.modified_by ? `${form.modified_by_first_name} ${form.modified_by_last_name}` : '-';
                    form.consentDate = form.modified_at;
                    consentRecords.push(form);
            }
            this.consents = new MatTableDataSource<any>(consentRecords);

        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    formatRecords(request: any) {
        const consentRecords = [];
        let position = 1;
        for (const consent of request) {
            for (const question of consent.questions) {
                for (const accepted of question.accepted) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        reportId: accepted.reportId,
                        consent: question.title,
                        status: 1,
                        displayName: `${accepted.childInfo.firstName} ${accepted.childInfo.lastName}`,
                        childId: accepted.childInfo.id,
                        consentDate: accepted.completed_at,
                        unique_id: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }

                for (const denied of question.denied) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        reportId: denied.reportId,
                        consent: question.title,
                        status: 0,
                        displayName: `${denied.childInfo.firstName} ${denied.childInfo.lastName}`,
                        childId: denied.childInfo.id,
                        consentDate: '-',
                        unique_id: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }

                for (const pending of question.pending) {
                    const recordModel = {
                        position,
                        id: consent.id,
                        reportId: pending.reportId,
                        consent: question.title,
                        status: -1,
                        displayName: `${pending.childInfo.firstName} ${pending.childInfo.lastName}`,
                        childId: pending.childInfo.id,
                        consentDate: '-',
                        unique_id: consent.unique_id
                    };
                    consentRecords.push(recordModel);
                    position++;
                }
            }
        }

        return consentRecords;
    }

    getDate(date) {
        const tempDate = date.split(' ');
        return `${tempDate[0]}`;
    }

    getTime(date) {
        const tempDate = date.split(' ');
        return `${tempDate[1]}`;
    }

    async showConsent(consent: any) {

        const child = this.children.find(c => c.id === consent.childId);
        await this.consentsFormService.showConsent(consent, this.user, child);
    }

    isNavigationToFormDisabled(consent: any) {
        return +consent.status === -1;
    }

    hasHistory(data: any[]) {
        // tslint:disable-next-line:variable-name
        const number = data.filter(d => d.status !== -1);

        return number.length === 0;
    }

    render() {
        this.displayCards = [];

        if (this.selectedOption.id === 1) {
            this.displayCards = this.customForms.data;
            // console.log(this.displayCards);
        } else if (this.selectedOption.id === 2) {
            this.displayCards = this.consents.data;
            // console.log(this.displayCards);
        } else if (this.selectedOption.id === 3) {
            this.displayCards = this.nonGDPRConsents.data;
            // console.log(this.displayCards);
        } else if (this.selectedOption.id === 4) {
            this.displayCards = this.consents.data.filter(c => c.status !== -1);
            // console.log(this.displayCards);
        }

        // if (this.selectedOption.id === 1) {
        //   this.displayCards = this.consents.data;
        // } else {
        //   if (this.selectedOption.id === 2) {
        //     this.displayCards = this.nonGDPRConsents.data;
        //   } else {
        //     this.displayCards = this.consents.data.filter(c => c.status !== -1);
        //   }
        // }
    }

    async showCustomForm(form) {
        const inputConfig = {
            edit: false,
            childId: form.childId ? form.childId : form.child_id,
            mode: true,
            parentId: this.user.id,
            unique_id: form.unique_id ? form.unique_id : form.form_unique_id,
            id: form.reportId ? form.reportId : form.id,
            update: true
        };

        // Use parentRequestForm for Single User Model (parent forms)
        if (form.parent_id) {
            await this.router.navigate(['/home/parentRequestForm'], {queryParams: inputConfig});
        } else {
            await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
        }
    }
}
